import { Dispatcher } from 'flux';
import { FSA, isFSA } from 'flux-standard-action';

export const dispatcher = new Dispatcher<FSA<any, any>>();


// WEBPACK FOOTER //
// ./src/dispatcher.ts